import {MoreOutlined} from "@ant-design/icons";
import {Dropdown, Menu, message, Modal} from "antd";
import {useNavigate} from "react-router-dom";
import {useDeleteLiveEvent} from "../../../../../features/live-events";
import {handleLiveClassLink} from "../../../../../utils/live-class";

interface LiveClassCardMenuV2Props {
  eventId: number;
  isCoHost?: boolean;
  hostUsername?: string;
  slug?: string;
  tinyUrl?: string;
}

const LiveClassCardMenuV2 = ({
  eventId,
  isCoHost,
  hostUsername,
  slug,
  tinyUrl,
}: LiveClassCardMenuV2Props) => {
  const deleteLiveEventMutation = useDeleteLiveEvent();
  const navigate = useNavigate();

  const handleDeleteModal = () => {
    Modal.confirm({
      title: `Confirm event deletion`,
      content: (
        <>
          <p>
            Are you sure you want to delete this live event? If there are registered
            attendees, they will be notified of the cancellation and will receive a full
            refund.
            <br />
            <br />
            This action cannot be undone.
          </p>
        </>
      ),
      okText: "Delete & cancel event",
      cancelText: "Exit",
      okType: "danger",
      okButtonProps: {
        size: "small",
        type: "primary",
      },
      cancelButtonProps: {
        size: "small",
        type: "ghost",
      },
      onOk() {
        return new Promise((resolve, reject) => {
          if (eventId) {
            resolve(
              deleteLiveEventMutation.mutate(eventId, {
                onSuccess: () => {
                  message.success("The selected event has been deleted successfully!");
                  navigate("/live-classes");
                },
              })
            );
          }
        }).catch(() => message.error("Failed to delete"));
      },
    });
  };

  const handleViewDetails = () => {
    if (isCoHost && hostUsername && slug) {
      const link = handleLiveClassLink({
        eventId,
        slug: slug,
        tinyUrl,
        username: hostUsername,
        windowNav: true,
      });
      window.open(link, "_blank");
    } else {
      navigate(`/live-classes/edit/${eventId}?activeTab=form`);
    }
  };

  const menu = (
    <Menu
      items={[
        {
          label: <div onClick={handleViewDetails}>View details</div>,
          key: "0",
        },
        {
          label: (
            <div
              onClick={() => navigate(`/live-classes/edit/${eventId}?activeTab=insights`)}
            >
              View attendees
            </div>
          ),
          key: "1",
        },
        {
          label: <div onClick={handleDeleteModal}>Delete</div>,
          danger: true,
          key: "2",
        },
      ]}
    />
  );

  return (
    <>
      <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
        <div
          style={{
            backgroundColor: "transparent",
            color: "#1C1726",
            border: "none",
            boxShadow: "none",
            cursor: "pointer",
          }}
        >
          <MoreOutlined />
        </div>
      </Dropdown>
    </>
  );
};

export {LiveClassCardMenuV2};
